import 'material-design-icons-iconfont/dist/material-design-icons.css';

import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

export default new Vuetify({
	icons: {
		iconfont: 'mdi', // default - only for display purposes
	},
	theme: {
		options: { customProperties: true },
		dark: false,
		themes: {
			light: {
				primary: '#FF5F05', //Orange
				secondary: '#4D88A1', //Cyan
				accent: '#009CEF', // Blue
				error: '#F44336', //Red
				anchor: '#FF5F05',
				background: '#FFFFFF',
				wallet: '#79467F', //Warm Violet
				green: '#7cb342',
			},
			dark: {
				primary: '#FF5F05',
			},
		},
	},
	breakpoint: {
		scrollBarWidth: 24,
	},
});
